module.exports = __webpack_public_path__ + "img/91.29dc587b.jpg";